import { Component, EventEmitter, Input, Output, OnInit, OnChanges, SimpleChange } from '@angular/core';

// import { d4dbService  } from '../../services/d4db.service';

import * as d3 from 'd3';
import * as d3Tip from 'd3-tip';
(d3 as any).tip = d3Tip;
// import * as dbox from '@dboxjs/core';
declare var dbox: any
import * as _ from 'lodash';

@Component({
  selector: 'dbox-radar',
  templateUrl: './dboxRadar.component.html',
  styleUrls: ['./dboxRadar.component.scss']
})
export class DboxRadarComponent implements OnInit, OnChanges {
  @Input() colors;
  @Input() topic;
  @Input() selectedOne;
  @Input() selectedTwo;
  @Output() onTopicChange = new EventEmitter();
  nacional;
  topicFormatted = '';
  chartData: any = {};

  ngOnChanges(changes: {[propKey: string]: SimpleChange}) {
    for (const propName of Object.keys(changes)) {
      const changedProp = changes[propName];
      const to = JSON.parse(JSON.stringify(changedProp.currentValue));
      if (changedProp.isFirstChange()) {
        // console.log(`Initial value of ${propName} set to ${to}`);
        // this.draw()
      } else {
        const from = JSON.stringify(changedProp.previousValue);
        // console.log(`${propName} changed from ${from} to ${to}`);
        if (propName === 'topic' && to !== null) {
          this.topicFormatted = this.getTopic()
          this.draw();
        }
        if (propName === 'selectedOne') {
          this.draw();
        }
        if (propName === 'selectedTwo') {
          this.draw();
        }

        // if(propName == 'hover' && to !== null && to.by !== 'bars') this.select(to);
        // if(propName == 'unhover'&& to !== null  && to.by !== 'bars') this.unselect(to);
      }
    }
  }

  /** ngOnInit: Init component, gets municipality data and stores it on chartData,
   * gets data from escuelas_localidad.csv and stores it in mun_localities
   * then draws Localities Scatter
   * @since v2
  */
  ngOnInit() {
    this.topicFormatted = this.getTopic()
    this.draw();
    $('.modal').modal();
  }

  getTopic() {
    switch (this.topic) {
      case 'coeficiente_TAI':
        return 'Coeficiente TAI';
      case 'opacidad':
        return 'Opacidad';
      case 'corrupcion':
        return 'Corrupción';
      case 'impunidad':
        return 'Impunidad';
    }
  }

  resetTopic(topic) {
    switch (topic) {
      case 'Coeficiente TAI':
        return 'coeficiente_TAI';
      case 'Opacidad':
        return 'opacidad';
      case 'Corrupción':
        return 'corrupcion';
      case 'Impunidad':
        return 'impunidad';
    }
  }

  draw() {
    const vm = this;
    const width = $('#radar').width(); // Getting scatter container size

    const cfg = {
      bindTo: '#radar',
      size: {
        width: width,
        height: 438,
        margin: {
          top: 75,
          bottom: 40,
          left: 75,
          right: 75
        },
      },
      data: {
        'csv': 'assets/data/coeficienteTAI_radar.csv',
        'filter': function(d, i){
          let bool = d.variable !== 'Coeficiente TAI' && d.CVE_ENT === '33';

          if (vm.selectedOne) {
            bool = d.variable !== 'Coeficiente TAI' && (d.CVE_ENT === '33' ||  d.CVE_ENT === vm.selectedOne.d.CVE_ENT)
          }
          if (vm.selectedTwo) {
            bool = d.variable !== 'Coeficiente TAI' && (d.CVE_ENT === '33' ||  d.CVE_ENT === vm.selectedTwo.d.CVE_ENT)
          }
          if (vm.selectedOne && vm.selectedTwo) {
            bool = d.variable !== 'Coeficiente TAI' && (d.CVE_ENT === '33' ||
              d.CVE_ENT === vm.selectedOne.d.CVE_ENT ||  d.CVE_ENT === vm.selectedTwo.d.CVE_ENT)
          }
          return bool
        }
      },
      legend: {
        enabled: true,
        at: {
          x: 600,
          y: 40
        }
      },
      'events': {
        'load': function(c){
          const chart = c;
          setTimeout(function() {
            d3.select('#radar svg g').attr('transform', 'translate(75, 115)');
            d3.select('#radar #radar-id-33 polygon').style('fill', 'none')
            d3.select('#radar #radar-id-33 polygon').style('stroke', '#00B7B7')
            d3.select('#radar #radar-id-33 polygon').style('stroke-dasharray', '5,8')
            d3.select('#radar #radar-id-33 polygon').style('stroke-width', '3')
            d3.select('#radar #radar-id-33 polygon').style('stroke-linecap', 'round')
            d3.selectAll('#radar #radar-id-33 circle').style('fill', '#00B7B7')
            d3.selectAll('#radar #radar-id-33 circle').style('stroke', '#00B7B7')

            if (vm.selectedOne) {
              d3.select('#radar #radar-id-' + vm.selectedOne.d.CVE_ENT + ' polygon')
                .style('fill', '#6b1e74')
                .style('fill-opacity', '0.65')
                .style('stroke-width', '2px');

              d3.select('#radar #radar-id-' + vm.selectedOne.d.CVE_ENT + ' polygon')
                .style('stroke', '#52115b');

              d3.selectAll('#radar #radar-id-' + vm.selectedOne.d.CVE_ENT + ' circle')
                .style('fill', '#6b1e74')
                .style('fill-opacity', '0.65')
                .style('stroke-width', '2px');

              d3.selectAll('#radar #radar-id-' + vm.selectedOne.d.CVE_ENT + ' circle')
                .style('stroke', '#52115b');
            }

            if (vm.selectedTwo) {
              d3.select('#radar #radar-id-' + vm.selectedTwo.d.CVE_ENT + ' polygon')
                .style('fill', '#cea052')
                .style('fill-opacity', '0.65')
                .style('stroke-width', '2px');

              d3.select('#radar #radar-id-' + vm.selectedTwo.d.CVE_ENT + ' polygon')
                .style('stroke', '#c6862a');
              d3.selectAll('#radar #radar-id-' + vm.selectedTwo.d.CVE_ENT + ' circle')
                .style('fill', '#cea052')
                .style('fill-opacity', '0.65')
                .style('stroke-width', '2px');

              d3.selectAll('#radar #radar-id-' + vm.selectedTwo.d.CVE_ENT + ' circle')
                .style('stroke', '#c6862a');
            }

            d3.selectAll('#radar .ticks circle')
              .style('stroke-linecap', 'round')
              .style('stroke-width', '2')
              .style('stroke-dasharray', '5,8')
              .style('stroke', '#b2b6c5')

            d3.selectAll('#radar line.axis')
              .style('stroke-linecap', 'round')
              .style('stroke-width', '2')
              .style('stroke-dasharray', '5,8')
              .style('stroke', '#b2b6c5')
            d3.selectAll('#radar rect.axis-label')
            .each(function(d, i) {
              const x = Number(d3.select(this).attr('x'));
              const y = Number(d3.select(this).attr('y'));

              d3.select(this).style('cursor', 'pointer')
                .attr('width', 80);

              d3.select(this).attr('y', function() {
                let adj = 0;
                if (i === 0) { // First One
                  adj =- 10;
                }
                if (i === 1 || i === 2) { // Second one, third one
                  adj =+ 25;
                }
                return y + adj;
              })

              d3.select(this).attr('x', function() {
                let adj = 0;
                if (i === 0 ) { // Second One
                  adj =+ 10;
                }
                if (i === 1 ) { // Second One
                  adj =+ 35;
                }

                if (i === 2 ) { // Third One
                  adj =- 15;
                }

                return x + adj;
              })

            }).on('click', function(d, i) {
              const t = vm.resetTopic(d['axis'])
              vm.onTopicChange.emit({'topic': t});
            })

            d3.selectAll('#radar text.axis-label')
              .each(function(d, i){
                const x = Number(d3.select(this).attr('x'));
                const y = Number(d3.select(this).attr('y'));

                d3.select(this).style('cursor', 'pointer');

                d3.select(this).attr('y', function() {
                  let adj = 0;
                  if (i === 0 ) { // First One
                    adj =- 1;
                  }
                  if (i === 1 || i === 2) { // First One
                    adj =+ 27;
                  }
                  return y + adj;
                })

                d3.select(this).attr('x', function() {
                  let adj = 0;
                  if (i === 1 ) { // Second One
                    adj =+ 20;
                  }

                  if (i === 2 ) { // Third One
                    adj =- 20;
                  }

                  return x + adj;
                })

              })
              .style('fill', 'white').style('font-family', '"Open Sans", sans-serif')
              .on('click', function(d, i) {
                const t = vm.resetTopic(d['axis'])
                vm.onTopicChange.emit({'topic': t});
              });

            d3.selectAll('#radar .ticks-labels .tick-label')
              .style('fill', '#96a1a3')
              .style('font-family', '"Open Sans", sans-serif')
              .style('font-size', '14px').style('font-weight', '700')
              .style('marginLeft', '50px')
              .text(function(d){
                return Number(d).toFixed(0)
              });
          }, 100);
        }
      },
      axesFrom: 'variable',
      polygonsFrom: 'NOM_ENT',
      valuesFrom: 'value',
      colors: ['#00B7B7', '#6B1E74', '#CEA052'],
      ticks: 5,
      xAxis: {enabled: false},
      yAxis: {enabled: false},
      axisLabelMargin: 30,
      scales: {
        x: {
          domain: [0, 100] // Fix domain from 0 to 100
        }
      }
    };

    const chrt = dbox.chart(cfg)
      .layer(dbox.radar)
      .end()
      .draw();
  }
}



// WEBPACK FOOTER //
// /home/azu/Proyectos/impunidad/impunidad-cero-tai/src/app/dboxRadar/dboxRadar.component.ts